import icone from '../../assets/images/Rectangle.png';
import icone2 from '../../assets/images/Icon.png';
import infoIcon from '../../assets/images/info.png';
import heartIcon from '../../assets/images/coeur.png';
import api from '../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CTab,
    CTabContent,
    CTabList,
    CTabPanel,
    CTabs,
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter
} from '@coreui/react'

const NurseDashboard = () => {
    const navigate = useNavigate();
    const [UserData, setUserData] = useState([]);
    const [appointments, setAppointments] = useState([]);
    const [departments, setDepartments] = useState([]);
    const popoverRefs = useRef([]);

    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);

    // Fetch appointments
    useEffect(() => {
        const fetchAppointments = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    throw new Error('Token not found');
                }

                const response = await api.get('/clinic/allbilling');
                let billingsData = response.data;

                setAppointments(billingsData);

            } catch (error) {
                console.error('Error fetching appointments:', error);
                toast.error("Failed to fetch appointments");
            }
        };

        if (UserData && UserData.hospital_id) {
            fetchAppointments();
        }
    }, [UserData]);

    // Function to check if vital signs exist for an appointment
    const fetchSignVitalStatus = async (appointmentId) => {
        try {
            const response = await api.get(`/clinic/signvitalforappointment/${appointmentId}`);
            return response.data.signVitaldata;
        } catch (error) {
            console.error('Error checking vital signs:', error);
            return false;
        }
    };

    const [patients, setPatients] = useState([]);

    const fetchPatients = async (hospitalIds) => {
        if (!hospitalIds || hospitalIds.length === 0) {
            console.error("Erreur: hospitalIds est vide ou non disponible");
            return;
        }
        try {
            // Faire l'appel API avec un tableau de hospitalIds
            const response = await api.get(`/clinic/patients`, {
                params: { hospitalIds } // Envoi d'un tableau d'IDs de hospital
            });

            console.log("Nombre de patients reçus:", response.data.patients.length);
            setPatients(response.data.patients);

        } catch (error) {
            console.error('Erreur lors de la récupération des patients:');
            if (error.response) {
                // La requête a été faite et le serveur a répondu avec un code d'état
                console.error('Données de réponse:', error.response.data);
                console.error('Statut:', error.response.status);
            } else if (error.request) {
                // La requête a été faite mais aucune réponse n'a été reçue
                console.error('Requête sans réponse:', error.request);
            } else {
                // Une erreur s'est produite lors de la configuration de la requête
                console.error('Erreur de configuration:', error.message);
            }
        }
    };

    useEffect(() => {
            if (UserData && UserData.hospital_id && Array.isArray(UserData.hospital_id) && UserData.hospital_id.length > 0) {
                // Vérifiez si hospital_id est un tableau et le passez à fetchPatients
                const hospitalIds = UserData.hospital_id;
                fetchPatients(hospitalIds);
            } else {
                console.error("UserData ou hospital_id non disponible pour fetchPatients");
            }
        }, [UserData]);

    // Fetch departments
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await api.get(`/api/departments`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    }
                });
                setDepartments(response.data.data);
            } catch (error) {
                console.error('Error fetching departments:', error);
            }
        };
        fetchDepartments();
    }, []);

    // Initialize popovers
    useEffect(() => {
        popoverRefs.current.forEach((popoverEl) => {
            if (popoverEl && window.bootstrap) {
                new window.bootstrap.Popover(popoverEl, {
                    html: true,
                    trigger: 'click',
                });
            }
        });
    }, [appointments]);

    const handleViewHistory = () => {
        navigate("/hospitaladmin/appointment_history");
    };

    const handleViewHistory2 = () => {
        navigate("/hospitaladmin/patient_details");
    };

    const handleviewcalendar = (doctorId) => {
        navigate(`/hospitaladmin/doctor/calendar/${doctorId}`);
    };

    const doctorId = UserData._id;

    return (
        <div className='enrol'>
            <div className="py-4 doc" style={{ fontFamily: 'Arial, sans-serif' }}>
                <p className="text-primary ">{new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
                <h2 className="text-primary fw-bold fs-1 mb-3" style={{color:"#0056b3"}}>Good morning, {UserData.firstname} {UserData.lastname}</h2>

                <div className="row mb-4">
                    <div className="col-md-4" style={{ borderRadius: "20px" }}>
                        <div className="card text-white mb-3 text-center" style={{ borderRadius: "20px" }} >
                            <div className="card-body" style={{
                                borderRadius: "20px", background: 'linear-gradient(180deg,rgb(73, 79, 75),rgb(77, 92, 77))'
                            }}>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <h5 className="card-title text-start">Current patient count</h5>
                                        <p className="card-text display-4 text-start">{patients.length}</p>
                                    </div>
                                    <div className='text-end align-items-left'>
                                        <img src={icone2} alt="Icon" />
                                        {/* <p className="mt-4">+11.01%</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4" style={{ borderRadius: "20px" }}>
                        <div className="card text-white mb-3 text-center" style={{ borderRadius: "20px" }}>
                            <div className="card-body" style={{ borderRadius: "20px", background: 'linear-gradient(180deg, #28A745, #4CAF50)' }}>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <h5 className="card-title text-start">Medications Due Now</h5>
                                        <p className="card-text display-4 text-start">{appointments.filter(apt => apt.paymentstatus === false).length || 0}</p>
                                    </div>
                                    <div className='text-end align-items-left'>
                                        <img src={icone2} alt="Icon" />
                                        {/* <p className="mt-4">+6.08%</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card text-white mb-3 text-center" style={{ borderRadius: "20px" }}>
                            <div className="card-body" style={{ borderRadius: "20px", background: ' linear-gradient(180deg, #FF9800, #FFC107)' }}>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <h5 className="card-title text-start">Tasks Due Today</h5>
                                        <p className="card-text display-4 text-start">{appointments.filter(apt => apt.paymentstatus === true).length || 0}</p>
                                    </div>
                                    <div className='text-end align-items-left'>
                                        <img src={icone2} alt="Icon" />
                                        {/* <p className="mt-4">+6.08%</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 bg-white" style={{ borderRadius: "20px" }}>
                        <div className="card p-4">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className='card-title fw-bold text-info' style={{color:"#0056b3"}}>Patients</h5>
                                    {/* <div className="text-end">
                                        <button className="btn btn-primary me-2" onClick={() => handleviewcalendar(doctorId)}>
                                            View calendar <i className="bi bi-calendar3"></i>
                                        </button>
                                        <button className="btn btn-primary" onClick={handleViewHistory}>
                                            View history <i className="bi bi-clock-history"></i>
                                        </button>
                                    </div> */}
                                </div>

                                {/* <div className="row mb-3">
                                    <div className="col-md-4" style={{ borderRadius: '15px' }}>
                                        <div className="input-group" style={{ borderRadius: '15px 0px 0px 15px' }}>
                                            <span className="input-group-text" style={{ borderRadius: '15px 0px 0px 15px' }}>
                                                <i className="bi bi-search"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search..."
                                                style={{ borderRadius: '0px 15px 15px 0px' }}
                                            />
                                        </div>
                                    </div>
                                </div> */}

                                <div className='patientlisttable'>
                                    <CTable className="mt-5 ctable-no-border " align="middle" responsive>
                                        <CTableHead>
                                            <CTableRow className='tablehead'>
                                                <CTableHeaderCell scope="col">ID</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">NAME</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">ADDRESS</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">LAST VISIT</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">PHONE</CTableHeaderCell>
                                                {/* <CTableHeaderCell scope="col">ACTION</CTableHeaderCell> */}
                                            </CTableRow>
                                        </CTableHead>
                                        <CTableBody>
                                            {patients.map((patient) => (
                                                <CTableRow className='ctable-row' key={patient._id}>
                                                    <CTableDataCell align="middle">{patient.patientId}</CTableDataCell>
                                                    <CTableDataCell>{patient.lastname} {patient.firstname}</CTableDataCell>
                                                    <CTableDataCell>{patient.address}</CTableDataCell>
                                                    <CTableDataCell>{patient.email}</CTableDataCell>
                                                    <CTableDataCell>{patient.phone}</CTableDataCell>
                                                    {/* <CTableDataCell>
                                                        <div className="flex items-center space-x-4">
                                                            <div className="dropdown-center p-0 bg-none" style={{ border: 'none' }}>
                                                                <FaEllipsisV
                                                                    className="bg-none border-0 p-0"
                                                                    data-coreui-toggle="dropdown"
                                                                    aria-expanded="true"
                                                                    style={{ border: 'none', color: 'Green' }}
                                                                />
                                                                <ul className="dropdown-menu">
                                                                    <li>
                                                                        <a
                                                                            className="dropdown-item"
                                                                            href={`/hospitaladmin/patientfilemedical/${patient._id}`}
                                                                        >
                                                                            <FaFolderOpen
                                                                                className="bg-none border-0 p-0"
                                                                                data-coreui-toggle="dropdown"
                                                                                aria-expanded="true"
                                                                                style={{ border: 'none' }}
                                                                            /> Open Folder
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <CButton
                                                                            // onClick={() => setVisibleEdit(true)} 
                                                                            onClick={() => handleEditClick(patient)}
                                                                            className="dropdown-item bg-none border-0" tabIndex={-1}>
                                                                            <FaEdit
                                                                                // onClick={() => setVisibleEdit(true)}
                                                                                className="bg-none border-0 p-0"
                                                                                data-coreui-toggle="dropdown"
                                                                                aria-expanded="true"
                                                                                style={{ border: 'none' }}
                                                                            /> Edit {patient?.firstname}
                                                                        </CButton>
                                                                        <EditPatientModal
                                                                            visibleEdit={visibleEdit}
                                                                            patientSelected={selectedUser}
                                                                            onClose={() => setVisibleEdit(false)}
                                                                            onPatientEdit={handlePatientEdited}
                                                                        />
                                                                    </li>
                                                                    <li>
                                                                        <a
                                                                            className="dropdown-item"
                                                                            href={`/patientcard/${patient._id}`}
                                                                        >
                                                                            <FaDownload
                                                                                className="bg-none border-0 p-0"
                                                                                data-coreui-toggle="dropdown"
                                                                                aria-expanded="true"
                                                                                style={{ border: 'none' }}
                                                                            /> Download
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </CTableDataCell> */}
                                                </CTableRow>
                                            ))}
                                        </CTableBody>
                                    </CTable>
                                </div>
                                <div className="text-end">Showing 1-{Math.min(appointments.length, 9)} of {appointments.length}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NurseDashboard;